import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase.ts';
import TopNavigation from '../components/Layout/TopNavigation';
import Icon from '../components/UI/Icon';
import { isTabletPortrait, setupDeviceDetection } from '../utils/deviceDetection';

function MenuPage({ setIsAuthenticated }) {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [isTabletPortraitMode, setIsTabletPortraitMode] = useState(false);

  useEffect(() => {
    fetchUserData();
  }, []);

  // Tablet portrait detection
  useEffect(() => {
    const cleanup = setupDeviceDetection(() => {
      setIsTabletPortraitMode(isTabletPortrait());
    });
    return cleanup;
  }, []);

  const fetchUserData = async () => {
    try {
      const user = auth.currentUser;
      if (user) {
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists()) {
          setUserData(userDoc.data());
        }
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };

  // Check if user has monthly_promo plan (games-only access)
  const hasGamesOnlyAccess = () => {
    if (!userData || !userData.subscription) return false;
    return userData.subscription.planKey === 'monthly_promo' ||
           userData.subscription.type === 'monthly_promo';
  };

  const handleNavigateToDashboard = () => {
    navigate('/dashboard');
  };

  const handleGameSelect = (gameId) => {
    if (gameId === 'home') {
      navigate('/dashboard');
    } else if (gameId === 'modules') {
      navigate('/dashboard?view=modules');
    } else if (gameId === 'materials') {
      navigate('/dashboard?view=materials');
    } else if (gameId === 'games') {
      navigate('/dashboard?view=games');
    } else if (gameId === 'settings') {
      navigate('/dashboard?view=settings');
    } else if (gameId === 'profile') {
      navigate('/dashboard?view=profile');
    } else if (gameId === 'theory') {
      navigate('/dashboard?view=theory');
    } else if (gameId === 'subscription') {
      navigate('/subscription');
    } else {
      navigate('/dashboard');
    }
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    navigate('/login');
  };

  return (
    <div className="app-container">
      <TopNavigation />
      <main className="main-content">
        <div className="container-fluid d-flex justify-content-center align-items-center" style={{ minHeight: 'calc(100vh - 76px)', padding: '2rem' }}>
          <div className={`row g-4 ${hasGamesOnlyAccess() ? 'justify-content-center' : ''}`} style={{ maxWidth: '1200px', width: '100%' }}>
            {!hasGamesOnlyAccess() && (
              <div className={isTabletPortraitMode ? "col-md-6" : "col-md-4"}>
                <button
                  className="btn w-100 d-flex flex-column align-items-center justify-content-center"
                  onClick={handleNavigateToDashboard}
                  style={{
                    aspectRatio: '1/1',
                    minHeight: '300px',
                    fontSize: '1.8rem',
                    fontWeight: 'bold',
                    backgroundColor: '#D4F1E4',
                    color: '#3A8B5C',
                    border: '2px solid #A8E6CF',
                    borderRadius: '24px',
                    transition: 'all 0.3s cubic-bezier(0.33, 1, 0.68, 1)',
                    transform: 'scale(1)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.05)';
                    e.currentTarget.style.backgroundColor = '#A8E6CF';
                    e.currentTarget.style.boxShadow = '0 8px 24px rgba(136, 216, 176, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.backgroundColor = '#D4F1E4';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <Icon name="home" className="mb-3" style={{ width: '80px', height: '80px' }} />
                  Startseite
                </button>
              </div>
            )}
            {!hasGamesOnlyAccess() && (
              <div className={isTabletPortraitMode ? "col-md-6" : "col-md-4"}>
                <button
                  className="btn w-100 d-flex flex-column align-items-center justify-content-center"
                  onClick={() => handleGameSelect('modules')}
                  style={{
                    aspectRatio: '1/1',
                    minHeight: '300px',
                    fontSize: '1.8rem',
                    fontWeight: 'bold',
                    backgroundColor: '#F0E6F0',
                    color: '#6B4C6B',
                    border: '2px solid #E4D0E4',
                    borderRadius: '24px',
                    transition: 'all 0.3s cubic-bezier(0.33, 1, 0.68, 1)',
                    transform: 'scale(1)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.05)';
                    e.currentTarget.style.backgroundColor = '#E4D0E4';
                    e.currentTarget.style.boxShadow = '0 8px 24px rgba(216, 191, 216, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.backgroundColor = '#F0E6F0';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <Icon name="modules" className="mb-3" style={{ width: '80px', height: '80px' }} />
                  Lernmodule
                </button>
              </div>
            )}
            <div className={isTabletPortraitMode ? "col-md-6" : "col-md-4"}>
              <button
                className="btn w-100 d-flex flex-column align-items-center justify-content-center"
                onClick={() => handleGameSelect('games')}
                style={{ 
                  aspectRatio: '1/1', 
                  minHeight: '300px', 
                  fontSize: '1.8rem', 
                  fontWeight: 'bold',
                  backgroundColor: '#FFFAF0',
                  color: '#B8794D',
                  border: '2px solid #FFE4B5',
                  borderRadius: '24px',
                  transition: 'all 0.3s cubic-bezier(0.33, 1, 0.68, 1)',
                  transform: 'scale(1)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.backgroundColor = '#FFE4B5';
                  e.currentTarget.style.boxShadow = '0 8px 24px rgba(255, 211, 182, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.backgroundColor = '#FFFAF0';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <Icon name="games" className="mb-3" style={{ width: '80px', height: '80px' }} />
                Spiele
              </button>
            </div>
            {!hasGamesOnlyAccess() && (
              <div className={isTabletPortraitMode ? "col-md-6" : "col-md-4"}>
                <button
                  className="btn w-100 d-flex flex-column align-items-center justify-content-center"
                  onClick={() => handleGameSelect('theory')}
                  style={{
                    aspectRatio: '1/1',
                    minHeight: '300px',
                    fontSize: '1.8rem',
                    fontWeight: 'bold',
                    backgroundColor: '#FFE0CA',
                    color: '#B8794D',
                    border: '2px solid #FFD3B6',
                    borderRadius: '24px',
                    transition: 'all 0.3s cubic-bezier(0.33, 1, 0.68, 1)',
                    transform: 'scale(1)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.05)';
                    e.currentTarget.style.backgroundColor = '#FFD3B6';
                    e.currentTarget.style.boxShadow = '0 8px 24px rgba(255, 211, 182, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.backgroundColor = '#FFE0CA';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <Icon name="explanation" className="mb-3" style={{ width: '80px', height: '80px' }} />
                  Sprachentwicklung verstehen
                </button>
              </div>
            )}
            <div className={isTabletPortraitMode ? "col-md-6" : "col-md-4"}>
              <button
                className="btn w-100 d-flex flex-column align-items-center justify-content-center"
                onClick={() => handleGameSelect('materials')}
                style={{
                  aspectRatio: '1/1',
                  minHeight: '300px',
                  fontSize: '1.8rem',
                  fontWeight: 'bold',
                  backgroundColor: '#E8F2F7',
                  color: '#5A9BC1',
                  border: '2px solid #C8E0ED',
                  borderRadius: '24px',
                  transition: 'all 0.3s cubic-bezier(0.33, 1, 0.68, 1)',
                  transform: 'scale(1)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.backgroundColor = '#C8E0ED';
                  e.currentTarget.style.boxShadow = '0 8px 24px rgba(184, 212, 227, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.backgroundColor = '#E8F2F7';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <Icon name="materials" className="mb-3" style={{ width: '80px', height: '80px' }} />
                Lernmaterialien
              </button>
            </div>
            <div className={isTabletPortraitMode ? "col-md-6" : "col-md-4"}>
              <button
                className="btn w-100 d-flex flex-column align-items-center justify-content-center"
                onClick={() => handleGameSelect('settings')}
                style={{ 
                  aspectRatio: '1/1', 
                  minHeight: '300px', 
                  fontSize: '1.8rem', 
                  fontWeight: 'bold',
                  backgroundColor: '#F8F9FA',
                  color: '#7A7A7A',
                  border: '2px solid #E9ECEF',
                  borderRadius: '24px',
                  transition: 'all 0.3s cubic-bezier(0.33, 1, 0.68, 1)',
                  transform: 'scale(1)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.backgroundColor = '#E9ECEF';
                  e.currentTarget.style.boxShadow = '0 8px 24px rgba(233, 236, 239, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.backgroundColor = '#F8F9FA';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <Icon name="profile" className="mb-3" style={{ width: '80px', height: '80px' }} />
                Profil
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default MenuPage;